// Room object kinds the Room Studio can place (CIN-15118); every one but `other` is a backend `RoomObjectType`.
// Unknown kinds from a ticket-system import are kept as `other` and rendered as a neutral box, never dropped.
export const ROOM_OBJECT_KINDS = [
    'screen',
    'stage',
    'stairs',
    'pillar',
    'wall',
    'door',
    'emergency_exit',
    'speaker',
    'projector',
    'table',
    // CIN-15126: guard walls, railings and stage lighting. A barrier, a railing and a stage may carry a profile
    // (a curved path); see outline/types.ts `ObjectProfile`.
    'barrier',
    'railing',
    'spotlight',
    // A counter along the front of a podium or a row: a dark ledge with cupholders and ventilation grilles.
    'counter',
    'truss',
    // A padded ottoman in front of a lounge recliner: a cushion on a short post (CIN-15402).
    'footstool',
    'other'
] as const;

export type RoomObjectKind = (typeof ROOM_OBJECT_KINDS)[number];

/**
 * Which way an object's front points along its footprint's local +y (the direction a seat looks): `1` toward
 * the screen, `-1` toward the audience. The projector lens looks at the screen; the screen surface, the stage
 * lip, the speaker drivers and the foot of the stairs face the audience; a spotlight's lens, like the projector's, looks at
 * the screen (see object-geometry.ts).
 */
export function frontOf(kind: RoomObjectKind): 1 | -1 {
    return kind === 'projector' || kind === 'spotlight' ? 1 : -1;
}
